import React from 'react';
import {
  Box,
  Typography, 
  Divider
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../components/Buttons/BackButton';
import Theme from '../Themes/main.theme';
import FrontOfficeFormStepsEdit from '../components/FormContainers/frontOffice/FrontOfficeFormStepsEdit';
import { IFrontOfficeFormValuesResp } from '../components/FormContainers/frontOffice/Types';
import FormSkeleton from '../components/Skeletons/FormSkeleton';
import HttpService from '../services/HttpService';
import { useTranslation } from 'react-i18next';

const EditFrontOffice = () => {
  const { id } = useParams();
  const [data, setData] = React.useState<IFrontOfficeFormValuesResp>({
    id: null,
    title: '',
    email: '',
    phone: '',
    is_enabled: false,
  });

  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const navigate = useNavigate();
  const {t} = useTranslation();
  const getData = async () => {
    try {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/registrations/front_office/${id}`);
      setData(resp.data);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };
  
  React.useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Box mt={2} mb={2}>
        <BackButton
          onClick={() => navigate(-1)}/>
      </Box>
      <Typography variant='h2' color={Theme?.labelColor?.main}>{t('Επεξεργασία Διεύθυνσης ΕΚΟΜΕ')}</Typography>
      <Divider sx={{mb: 5, mt: 2, border: 1, color: Theme?.dividerColor?.main}}/>        
      {isLoading
        ? <FormSkeleton lines={4} />
        : <FrontOfficeFormStepsEdit initialValues={data}/>
      }
    </>
  );
};

export default EditFrontOffice;